import { render } from "./PrinterTemplate.vue?vue&type=template&id=0a6b3191"
import script from "./PrinterTemplate.vue?vue&type=script&lang=js"
export * from "./PrinterTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script